<template>
    <div class="bg-mission-item rounded-lg my-8" data-cy="card_mission_game_match">
        <div class="box-mission grid items-center relative" data-cy="btn_mission_game_match_detail" @click="clickToDetail()">
            <div class="box-text p-4">
                <div class="font-bold text-18 text-a-white-ffffff pb-3" data-cy="text_mission_game_match_title">
                    <template v-for="(line, index) in titleMatchLines" :key="index">
                        <br v-if="index > 0" />
                        {{ line }}
                    </template>
                </div>
                <div class="w-28 flex justify-center items-center bg-a-white-ffffff font-bold text-14 text-a-blue-2140a6 rounded-sm py-2.5"
                    data-cy="btn_mission_game_match_play"
                    v-if="!isWin && missionGameDate">
                    <div class="pr-3"><img data-cy="img_mission_game_match_play_icon" :src="icPlayGame" /></div>
                    <div>{{ lbl.mission.play_game }}</div>
                </div>
                <div class="w-28 flex justify-center items-center bg-a-gray-c4c4c4 font-bold text-14 text-a-white-ffffff rounded-sm py-2.5"
                    data-cy="btn_mission_game_match_play_disabled"
                    v-else>
                    <div class="pr-3"><img data-cy="img_mission_game_match_play_win_icon" :src="icPlayGameWin" /></div>
                    <div>{{ lbl.mission.play_success }}</div>
                </div>
                <div class="font-medium text-12 text-a-yellow-ffca66 pt-1" data-cy="text_mission_game_match_play_win" v-if="isWin">
                    {{ lbl.mission.play_win }}
                </div>
            </div>
            <div class="box-img absolute bottom-0 -right-3 my-auto justify-self-end">
                <img data-cy="img_mission_game_match" :src="imgGame" />
            </div>
        </div>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import CacheHelper from '@/helper/CacheHelper';
import ConfigManager from '@/config/ConfigManager.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//service
import MissionService from '../../service/MissionService.js';

export default {
    name: 'MissionGameMatch',
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    props: {
        game: { type: Object, default: null }
    },
    data: function(){
        return {
            isWin: false,
            missionGameDate: false,
            titleMatch: '',
            icPlayGame: null,
            icPlayGameWin: null,
            imgGame: null,
        }
    },
    computed: {
        titleMatchLines() {
            return Util.splitByBrTag(this.titleMatch);
        },
    },
    created: async function(){
        let match = await this.getMissionGameMatchDetailBlob();
        this.checkGameWin();
        if (match) {
            this.titleMatch = this.localeCode == 1054 ? match.title_th : match.title_en;
        }
        this.imgUrl();
    },
    methods: {
        getMissionGameMatchDetailBlob: function () {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                MissionService.getMissionGameMatchDetailConfig()
                    .subscribe({
                        next: (res) => {
                            this.modal.loadingModal.hide();
                            resolve(res.game);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            this.modal.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        checkGameWin: function(){
            let gameConfig = this.game;
            if (!gameConfig) {
                return;
            }
            let currentDate = new Date();
            let start = DatetimeHelper.unixTimestampToDate(gameConfig.StartDate);
            let end = DatetimeHelper.unixTimestampToDate(gameConfig.EndDate);

            if (currentDate >= start && currentDate <= end) {
                this.missionGameDate = true;
            }
            if (gameConfig.IsPlayed) {
                this.isWin = true;
            }
        },
        clickToDetail: function(){
            if(this.isWin) return;
            if(!this.game) {
                this.showGameMatchError();
                return;
            }

            if (this.game.TargetPoint != null) {
                let cache = new CacheHelper('session');
                cache.setCache('target_point', this.game.TargetPoint);
            }

            this.tracking.event('mission_game', 'mission_game_match', null, null);
            this.$router.push('/mission/detailandcondition/game/match');
        },
        showGameMatchError: function() {
            if (this.modal.errorModal) {
                this.modal.errorModal
                    .clearModal()
                    .setMsg(this.lbl.mission.game_match_error)
                    .show();
            }
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            this.imgGame = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-game.png`;
            this.icPlayGame = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-play-game.png`;
            this.icPlayGameWin = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-play-game-win.png`;
        },
    }
}
</script>
<style lang="scss" scoped>
.bg-mission-item{
    min-height: 144px;
    background-image: linear-gradient(to right, #1a63c9 22%, #2140a6 65%);
}
.box-mission{
    min-height: 180px;

    .box-text{
        width: 55%;
    }
    .box-img{
        width: 45%;
    }
}
</style>
